import { render, staticRenderFns } from "./trainVideo1.vue?vue&type=template&id=71961df3&scoped=true&"
import script from "./trainVideo1.vue?vue&type=script&lang=js&"
export * from "./trainVideo1.vue?vue&type=script&lang=js&"
import style0 from "./trainVideo1.vue?vue&type=style&index=0&id=71961df3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71961df3",
  null
  
)

export default component.exports